import React from 'react';
import Skeleton from '../../shared/TailwindComponents/Skeleton';

interface FileTypeSkeletonProps {
  fileType: 'docx' | 'pdf' | 'excel' | 'text' | 'unknown';
}

/**
 * The preview's first-load placeholder.
 *
 * This was four hand-rolled `bg-gray-200 dark:bg-gray-700` bar stacks, each
 * pinned to `h-[calc(100vh-110px)]` — so it neither flipped cleanly with the
 * theme nor fitted the pane it was actually rendered into. All four shapes
 * already exist in the shared `Skeleton`; the only thing worth keeping here is
 * the mapping from file type to shape.
 */
const VARIANT: Record<FileTypeSkeletonProps['fileType'], 'document' | 'table' | 'prose'> = {
  docx: 'document',
  pdf: 'document',
  excel: 'table',
  text: 'prose',
  unknown: 'document',
};

const FileTypeSkeleton: React.FC<FileTypeSkeletonProps> = ({ fileType }) => (
  // Fills the height it is given rather than guessing at the viewport.
  <div className="w-full flex-1 min-h-0 overflow-hidden p-6">
    <Skeleton variant={VARIANT[fileType] || 'document'} rows={8} />
  </div>
);

export default FileTypeSkeleton;
